module.exports = __webpack_public_path__ + "static/media/icon-social-networking.f3002f8f.png";